module.exports = __webpack_public_path__ + "media/entities/2304-97792f29.png";